/**
 * The parent place's "known place" notes in the atlas details strip (HNR-G10).
 * Renders nothing unless the character has discovered a pocket map belonging to
 * this place, so an undiscovered secret leaves no name, count or marker.
 */
import React from 'react';
import type { WorldMapKnownPlace } from './worldMapKnownPlaces';

export const WorldMapKnownPlaceNotes: React.FC<{
  places: readonly WorldMapKnownPlace[] | undefined;
  currentMapId: string | null;
}> = ({ places, currentMapId }) => {
  if (!places || places.length === 0) return null;
  return <>
    {places.map(place => (
      <span key={place.id} className="world-map-strip-known" data-known-place={place.id}
        data-known-place-current={place.id === currentMapId || undefined}>
        Known place: {place.name}{place.id === currentMapId ? ' (you are here)' : ''}
      </span>
    ))}
  </>;
};
